import React from 'react';

import styles from './ExportApiKeySettings.module.scss';
import { useGeneralSettings } from '../useGeneralSettings';
import { useDispatch } from 'react-redux';
import { fetchExportV4ApiKey } from '../generalSettingsActions';
import Spinner from '../../../moderation-v2/comments-and-posts/dashboard/components/Spinner/Spinner';

export function ExportApiKeySettings() {
  const { exportV4ApiKey, exportV4ApiKeyLoading } = useGeneralSettings();
  const dispatch = useDispatch();

  function onClick() {
    dispatch(fetchExportV4ApiKey());
  }

  return exportV4ApiKey ? (
    <span className={styles.text}>Export v4 API key: {exportV4ApiKey}</span>
  ) : (
    <button onClick={onClick} className={styles.button}>
      {exportV4ApiKeyLoading ? <Spinner size="normal" /> : 'Get Export v4 API key'}
    </button>
  );
}
